import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {visitedPageActions} from "_actions";
import {buildSaveVisitedPagePayload, setToLocalstorage} from "../../utilities/visitedpage.utils";

export default function useVisitedPage() {
    const dispatch = useDispatch();
    const url = new URL(document.location)?.href;

    useEffect(() => {
        saveVisitedPage();
    }, [url]);

    const visitedPage = useSelector(state => state.visitedPage.saveVisitedPage?.visitedPage);
    const loading = useSelector(state => state.visitedPage.saveVisitedPageLoading);

    if(!loading && !_.isEmpty(visitedPage)) {
        setToLocalstorage(visitedPage);
    }

    const saveVisitedPage = () => {
        const payload = buildSaveVisitedPagePayload(url);
        if(!payload) {
            return;
        }
        dispatch(visitedPageActions.saveVisitedPage(payload));
    }
}